import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import SubscriptionAdminPage from "./ui";

const SubscriptionAdmin = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <SubscriptionAdminPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default SubscriptionAdmin;

